import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Spinner } from '@/components/ui/FeedBack/Spinner';
import { DeleteIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
/**
 * アップロードされたファイルを表示するためのベースコンポーネント
 * @param props
 * @constructor
 */
export const UploadFileBase = (props) => {
    const { children, className = '', isDeletable = false, isUploading = false, onClickDelete, } = props;
    return (_jsxs("div", Object.assign({ className: clsx('flex flex-nowrap items-center gap-x-8 w-full', className) }, { children: [isUploading && (_jsx(Spinner, { className: 'shrink-0', color: 'rainbow', size: 'xs' })), _jsx("div", Object.assign({ className: 'grow sm:grow-0' }, { children: children })), isDeletable && !isUploading && (_jsx("button", Object.assign({ className: 'group text-0 shrink-0', onClick: onClickDelete, type: 'button' }, { children: _jsx(DeleteIcon, { className: 'group-hover:text-gray-600', color: 'base', size: 'md' }) })))] })));
};
